export default __webpack_public_path__ + "static/media/valentin.b860e851.jpg";